import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
}

export const loadingSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    loadingStart: (state) => {
      state.loading = true
    },
    loadingStop: (state) => {
        state.loading =false
    },
    // incrementByAmount: (state, action) => {
    //   state.value += action.payload
    // },
  },
})

// Action creators are generated for each case reducer function
export const { loadingStart, loadingStop } = loadingSlice.actions

export default loadingSlice.reducer